import { ValidationErrors } from '@angular/forms';

import { Activity } from 'app/shared/features/activity-selector/models';

import { MeasurementType } from '../models/measurement-type';
import { convertFormValueToNumberOrUndefined, isNumberWithPointSeparator } from './form.utils';

function getFormatErrorMessage(activity: Activity | undefined) {
    let errorMessage = 'ERROR.TITLE.WRONG_AMOUNT';
    let formatErrorValue = '';
    if (activity) {
        errorMessage = `ERROR.TITLE.WRONG_AMOUNT_FORMAT`;
        // Regular activity that has result determination type and no measurement type
        if (activity.activityType === 20 && activity.measurementType !== MeasurementType.noMeasurementType) {
            formatErrorValue = `0.${'0'.repeat(activity.measurementUnitNrOfDecimalsAfterDecimalPoint)} - ${'9'.repeat(
                activity.measurementUnitNrOfDecimalsBeforeDecimalPoint,
            )}.${'9'.repeat(activity.measurementUnitNrOfDecimalsAfterDecimalPoint)}`;
        } else {
            // Packing activity that has measurement type and no result determination type
            formatErrorValue = `0.${'0'.repeat(activity.nrOfDecimalsAfterDecimalPoint)} - ${'9'.repeat(
                activity.nrOfDecimalsBeforeDecimalPoint,
            )}.${'9'.repeat(activity.nrOfDecimalsAfterDecimalPoint)}`;
        }
    }

    return { format: errorMessage, errorValue: formatErrorValue };
}

export function getMaxAmountResult(activity: Activity | undefined) {
    if (activity?.activityType === 20 && activity.measurementType !== MeasurementType.noMeasurementType) {
        return activity ? 10 ** activity.measurementUnitNrOfDecimalsBeforeDecimalPoint : undefined;
    }
    return activity ? 10 ** activity.nrOfDecimalsBeforeDecimalPoint : undefined;
}

export function isAmountResultValidOrEmpty({
    amountResult,
    activity,
}: {
    amountResult: number | undefined | null;
    activity: Activity | undefined;
}) {
    if (amountResult === undefined || amountResult === null) return true;

    if (amountResult < 0) return false;

    const maxValue = getMaxAmountResult(activity);
    if (maxValue !== undefined && amountResult >= maxValue) return false;

    // validating precision
    let maxPrecision: number | undefined = 0;
    if (activity?.activityType === 20 && activity.measurementType !== MeasurementType.noMeasurementType) {
        maxPrecision = activity?.measurementUnitNrOfDecimalsAfterDecimalPoint;
    } else {
        maxPrecision = activity?.nrOfDecimalsAfterDecimalPoint;
    }

    if (maxPrecision !== undefined) {
        const a = amountResult * 10 ** maxPrecision;
        return Math.abs(a - Math.trunc(a)) < 10 ** (-10 + maxPrecision);
    }

    return true;
}

export function validateAmountResultForActivity({
    amountString,
    activity,
}: {
    amountString: string;
    activity: Activity | undefined;
}): ValidationErrors | null {
    if (!isNumberWithPointSeparator(amountString)) return getFormatErrorMessage(activity);

    const amountResult = convertFormValueToNumberOrUndefined(amountString);
    const isValid = isAmountResultValidOrEmpty({ amountResult, activity });
    return isValid ? null : getFormatErrorMessage(activity);
}

export function isAmountResultProvided(amountResult: number | undefined | null) {
    return amountResult !== undefined || amountResult === 0 || amountResult === null;
}
